import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Clock } from 'lucide-react';
import { cn } from '@/lib/utils';

interface TimeSelectorProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
  id?: string;
}

export const TimeSelector = ({ value, onChange, className, placeholder = "Sélectionner l'heure", id }: TimeSelectorProps) => {
  // Générer les heures (00-23)
  const hours = Array.from({ length: 24 }, (_, i) => {
    const hour = i.toString().padStart(2, '0');
    return { value: hour, label: hour };
  });

  // Générer les minutes (00, 15, 30, 45)
  const minutes = [
    { value: '00', label: '00' },
    { value: '15', label: '15' },
    { value: '30', label: '30' },
    { value: '45', label: '45' }
  ];

  const [selectedHour, selectedMinute] = value ? value.split(':') : ['09', '00'];

  const handleHourChange = (hour: string) => {
    onChange(`${hour}:${selectedMinute}`);
  };

  const handleMinuteChange = (minute: string) => {
    onChange(`${selectedHour}:${minute}`);
  };

  return (
    <div className={cn("flex gap-2", className)} id={id}>
      <div className="flex-1">
        <Select value={selectedHour} onValueChange={handleHourChange}>
          <SelectTrigger className="relative">
            <div className="flex items-center gap-2">
              <Clock className="h-4 w-4 text-muted-foreground" />
              <span>{selectedHour || "Heure"}</span>
            </div>
          </SelectTrigger>
          <SelectContent className="max-h-[200px]">
            {hours.map((hour) => (
              <SelectItem key={hour.value} value={hour.value}>
                {hour.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      <div className="flex-1">
        <Select value={selectedMinute} onValueChange={handleMinuteChange}>
          <SelectTrigger>
            <SelectValue placeholder="Min" />
          </SelectTrigger>
          <SelectContent>
            {minutes.map((minute) => (
              <SelectItem key={minute.value} value={minute.value}>
                {minute.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};